import { useCallback, useState } from 'react';

import type { ContentSummaryDialogProps } from '../components/ContentSummaryDialog';

export const usePublicationSummaryDialog = ({ onSettingsOpen }: { onSettingsOpen: () => void }) => {
    const [state, setState] = useState<
        Pick<ContentSummaryDialogProps, 'isOpen' | 'onConfirm' | 'publicationSourceType'>
    >({
        isOpen: false,
        publicationSourceType: 'publish',
        onConfirm: () => {},
    });

    const closeSummaryDialog = useCallback(() => {
        setState((prevState) => ({ ...prevState, isOpen: false }));
    }, []);

    const openSummaryDialog = useCallback(
        (props: Pick<ContentSummaryDialogProps, 'onConfirm' | 'publicationSourceType'>) => {
            const { onConfirm, publicationSourceType } = props || {};
            const handleConfirm = () => {
                onConfirm?.();
                closeSummaryDialog();
            };
            setState({
                isOpen: true,
                publicationSourceType,
                onConfirm: handleConfirm,
            });
        },
        [closeSummaryDialog],
    );

    const openSettings = useCallback(() => {
        onSettingsOpen();
        closeSummaryDialog();
    }, [closeSummaryDialog, onSettingsOpen]);

    return {
        dialogProps: { ...state, onClose: closeSummaryDialog, onSettingsClick: openSettings },
        openSummaryDialog,
    };
};
